import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Button } from 'react-bootstrap';
import RegBreadcrumb from '../components/RegBreadcrumb';
import { TailSpin } from 'react-loader-spinner';
import { accountService } from '../functions/registerApi';
// import {  }

import { authService } from '../functions/authenticate';
import { promoService } from '../functions/promoApi';
import '../scss/Payment.scss';

const Payment = ({ itemList, marathonPrice, marathonLabel, userID, setUserID, login, setLogin, setUserName, authToken, setAuthToken, deliveryFee }) => {

    const navigate = useNavigate();
    const [total, setTotal] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [paymentID, setPaymentID] = useState('');
    const [promo, setPromo] = useState('');
    const [runnerList, setRunnerList] = useState([]);
    const [selectedList, setSelectedList] = useState([]);
    const [desc, setDesc] = useState('');
    const [contactName, setContactName] = useState('');
    const [email, setEmail] = useState('');
    const [contact, setContact] = useState('');
    const [runDiscountRate, setRunDiscountRate] = useState({
        "42KM" : 0,
        "21KM" : 0,
        "10KM" : 0,
        "5KM" : 0
    });
    const [isFree, setIsFree] = useState(false);
    const [isPost, setIsPost] = useState(false);
    const [isPaid, setIsPaid] = useState(true);
    const [applyPromo, setApplyPromo] = useState(false);
    const [remakePayment, setRemakePayment] = useState(false);

    useEffect(() => {
        
        let newRunnerList = localStorage.getItem('runnerList')===null ? [] : JSON.parse(localStorage.getItem('runnerList'));
        let newSelectedList = localStorage.getItem('selectedList')===null ? [] : JSON.parse(localStorage.getItem('selectedList'));
        let newPromo = localStorage.getItem('promoCode')===null ? '' : localStorage.getItem('promoCode');
        let paymentID = localStorage.getItem('paymentID')===null ? '' : localStorage.getItem('paymentID');
        let RemakePayment = localStorage.getItem('RemakePayment')==='true' ? true : false;
        let isTestFree = localStorage.getItem('isFreeTest')==='true' ? true : false;
        
        console.log("localstorage: " + isTestFree);
        console.log("localstorage: " + paymentID);
        console.log("localstorage: " + newPromo);
        console.log("localstorage: " + newRunnerList);
        console.log("localstorage: " + newSelectedList);

        setPaymentID(paymentID);
        setRemakePayment(RemakePayment);
        setPromo(newPromo);
        setRunnerList(newRunnerList);
        setSelectedList(newSelectedList);


        accountService.getPaymentByID(paymentID)
            .then(response => {
                // console.log(response);
                if(response.status)
                {
                    if(response.body.payment.status === '1') {
                        navigate('/PaymentDone/' + response.body.payment.paymentID);
                    } else {
                        setIsPaid(false);
                    }
                } else {
                    setIsPaid(false);
                }
            })
            .catch(err => console.error(err));

        accountService.getUser(userID)
            .then(response => {
                // console.log(response);
                if(response.status)
                {
                    let user = response.body.user;
                    setContactName(user.firstname + ' ' + user.lastname);
                    setEmail(user.email);
                    setContact(user.phone_no);
                }
                else
                {
                    const err = response.body;
                }
            })
            .catch(err => console.error(err));

        accountService.getUser(userID)
            .then(response => {
                // console.log(response);
                if(response.status)
                {
                    let user = response.body.user;
                    setContactName(user.firstname + ' ' + user.lastname);
                    setEmail(user.email);
                    setContact(user.phone_no);
                }
                else
                {
                    const err = response.body;
                }
            })
            .catch(err => console.error(err));

        
        if(!RemakePayment){
            if(newPromo === "" || newPromo === null || newPromo === 'FORNEUTEST' || newPromo === 'KMATESTRM1') {
                setIsPost(true);
                setApplyPromo(true);
                calPrice(newRunnerList, newSelectedList, runDiscountRate,newPromo );
            } else if (newPromo === 'FORNEUTESTFREE' || newPromo === 'KMATESTFREE' || isTestFree) {
                setIsFree(true);
                setApplyPromo(true);
                calPrice(newRunnerList, newSelectedList, runDiscountRate, newPromo);
            } else {
                promoCheck(newPromo, paymentID);
            }
        } else {
            accountService.remakePayment(paymentID)
                .then(response => {

                    // console.log(response);
                    let status = response.status;
                    let res = response.body;

                    if(status) {
                        setPaymentID(res.new_paymentID);
                        calPrice(runnerList, selectedList, runDiscountRate, promo);
                        setApplyPromo(true);
                    } else {
                        navigate('/PaymentDone/' + paymentID);
                    }

                })
                .catch(err => console.error(err));
        }

    }, []);

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if(token==='' || token===null)
        {
            navigate('/Login');
        }
        else
        {
            // console.log(token);
            authService.validateAuthToken(token)
                .then((response) => {
                    // console.log(response);
                    if(!response.status)
                    {
                        navigate('/Login');
                    }
                    else if(!login)
                    {
                        let data = response.body.user;
                        setUserID(data.individualID);
                        localStorage.setItem('userID', data.individualID);
                        // console.log(localStorage.getItem('userID'));
                        setLogin(true);

                        setUserName(data.firstname + ' ' + data.lastname);
                        localStorage.setItem('userName', data.firstname + ' ' + data.lastname);
                        
                        setAuthToken(response.body.token);
                        localStorage.setItem('authToken', response.body.token);

                    }
                })
                .catch((error) => {
                    console.log(error);
                    navigate('/Login');
                })
        }
    }, [authToken]);

    useEffect(() => {
        setIsPost(true);
    }, [isFree]);

    useEffect(() => {
        if(remakePayment && paymentID!=localStorage.getItem('paymentID') && total!=0) {
            setRemakePayment(false);
        }
    }, [paymentID, remakePayment, total]);

    useEffect(() => {

        if(contact==='') {
            setContact('+6082 2887 67');
        }

        if(!remakePayment && applyPromo && isPost && !isPaid && total!==0 && paymentID!=='' && desc!=='' && contactName!=='' && contact!=='' && email!=='')
        {
            document.getElementById("ePayment").submit();
        }

    }, [remakePayment, applyPromo, isPost, isPaid, paymentID, total, desc, contactName, email, contact]);

    const calPrice = (newRunnerList, newSelectedList, newRunDiscountRate, newPromo) => {
        let tax = 0;
        let newDiscount = 0;
        let newTotal = 0;
        let newSubtotal = 0;
        let itemDesc = '';
        let obj = {
            merchandiseCollection : 'Self-Collection',
            deliveryAddress : '',
            deliveryCity : '',
            deliveryPostcode : '',
            deliveryState : '',
            deliveryCountry : ''
        };

        let deliveryInfo = localStorage.getItem('deliveryInfo')===null ? obj : JSON.parse(localStorage.getItem('deliveryInfo'));


        // console.log("Runner:" + newRunnerList);
        // console.log("Merchandise:" + newSelectedList);


        newRunnerList.map((runner, index) => {
            // console.log("runner"+index+" - "+runner.category);
            newSubtotal += marathonPrice[runner.category];
            newDiscount += marathonPrice[runner.category] * newRunDiscountRate[runner.category];
            // console.log("Discount: " + newDiscount);
            if(newPromo !== "") {
                itemDesc += 'Promo - ' + newPromo + ' | ';
            }
            itemDesc += runner.category + ' ' + runner.categoryType + ' | ' + runner.tshirt_size + (runner.finisher!=='' ? ' | ' + runner.finisher : '') + ', ';
        });
        newSelectedList.map((item, index) => {

            newSubtotal += itemList[item.item].price * item.quantity;
            itemDesc += itemList[item.item].name + ' | ' + item.size + ' | x' + item.quantity;
            if(deliveryInfo.merchandiseCollection === "Delivery Service") {
                newSubtotal += deliveryFee * item.quantity;
                itemDesc += " | delivery service";
            }
            itemDesc += ', ';
        });

        // For testing
        if(newPromo === 'FORNEUTEST' || newPromo === 'KMATESTRM1')
        {
            newTotal = 1;
        }
        else
        {
            newTotal = newSubtotal + tax - newDiscount;
            newTotal = newTotal.toFixed(2);
        }

        setTotal(newTotal);
        setDesc(itemDesc);
        setApplyPromo(true);
    }

    const promoCheck = (promo, paymentID) => {

        promoService.getPromoDetail(promo)
            .then((response) => {

                console.log(response);

                if(response.status) {
                    let type = response.body.type;
                    let newDiscountRate = runDiscountRate;
                    
                    if(type === 1) {
                        newDiscountRate = response.body.promoRate;
                        setRunDiscountRate(response.body.promoRate);
                    } else if(type === 2) {
                        switch(response.body.payment_type) {
                            case 'Sponsored' : 
                                setIsFree(true);
                                break;
    
                            case 'Invoicing' : 
                                setIsFree(true);
                                break;
    
                            case 'Online Payment' : 
                                setIsFree(false);
                                break;
                        }
                    }

                    let newRunnerList = localStorage.getItem('runnerList')===null ? [] : JSON.parse(localStorage.getItem('runnerList'));
                    let newSelectedList = localStorage.getItem('selectedList')===null ? [] : JSON.parse(localStorage.getItem('selectedList'));
                    calPrice(newRunnerList, newSelectedList, newDiscountRate, promo);
                    

                } else {
                    alert("Invalid promo code being used");
                    navigate('/Register/');
                }
                
            })
            .catch((err) => {
                console.error(err.response);
            });

        // promoService.checkPromo(promo, paymentID)
        //     .then((response) => {
        //         // console.log(response);
        //         if(response.status) {
                    
        //             let data = response.body.code;
        //             let promo_type = data.payment_type;

        //             // console.log(promo_type);
                    
        //             switch(promo_type) {
                        
        //                 case 'Sponsored' : 
        //                     setIsFree(true);
        //                     break;

        //                 case 'Invoicing' : 
        //                     setIsFree(true);
        //                     break;

        //                 case 'Online Payment' : 
        //                     setIsFree(false);
        //                     break;

        //             }

        //             // setIsPost(true);
        //             calPrice();

        //         } else {

        //             alert("Invalid promo code being used");
        //             navigate('/Register/');

        //         }

        //     })
        //     .catch((err) => {
        //         console.error(err);
        //     });

    }



    return (
        <Container fluid="lg" className='wrapper'>

            <h1 className="title">Payment</h1>
            <RegBreadcrumb page={3} />

            <Row className="payment-loading-box">
                <h4 className="d-flex align-items-center">
                    <TailSpin
                        height="40"
                        width="40"
                        color="#e42231"
                        ariaLabel="tail-spin-loading"
                        radius="1"
                        wrapperStyle={{width: 'fit-content'}}
                        wrapperClass=""
                        visible={true}
                    />
                    <div className="loading-text">
                        Please wait while page redirecting to ipay payment gateway...
                    </div>
                </h4>

                <p>
                    <strong>
                        <span>IMPORTANT NOTICE:</span>
                    </strong>
                    <br /><br />
                    Kindly return to the official website after successful payment from Mobile88 payment gateway window. <u><strong>DO NOT CLOSE THE BROWSER UNTIL THE REGISTRATION CONFIRMATION CHIT IS DISPLAYED ON THE   WINDOW </strong></u>. For <u><strong>PROOF OF PURCHASE </strong></u> kindly print out the <strong>PARTICIPANT REGISTRATION CONFIRMATION CHIT</strong> along with the <strong>OFFICIAL RECEIPT FROM Mobile88</strong> which will be needed for your entrance to this event. A copy of these documents will be sent to your email listed in your registration  account.                    
                </p>
            </Row>

            {isFree ? (
                // <form id="ePayment" method="post" action="https://www.marathonkuching.com/register2/payment/payment_response.php" >
                <form id="ePayment" method="post" action={process.env.REACT_APP_PUBLIC_URL + '/payment/payment_response.php'} >
                    <input name="RefNo" type="hidden" value={paymentID} />
                    <input name="manual" type="hidden" value="1" />
                    <input name="amount" type="hidden" value={total} />
                    <input name="currency" type="hidden" value="MYR" />
                    <input name="prodDesc" type="hidden" value={desc} />
                    <input name="contact_name" type="hidden" value={contactName} />
                    <input name="contact_email" type="hidden" value={email} />
                    <input name="contact_no" type="hidden" value={contact} />
                </form>
            ) : (
                // <form id="ePayment" method="post" action="https://www.marathonkuching.com/register2/payment/payment_request.php" >
                <form id="ePayment" method="post" action={process.env.REACT_APP_PUBLIC_URL + '/payment/payment_request.php'} >
                    <input name="payment" type="hidden" value="2" />
                    <input name="refID" type="hidden" value={paymentID} />
                    <input name="amount" type="hidden" value={total} />
                    <input name="currency" type="hidden" value="MYR" />
                    <input name="prodDesc" type="hidden" value={desc} />
                    <input name="contact_name" type="hidden" value={contactName} />
                    <input name="contact_email" type="hidden" value={email} />
                    <input name="contact_no" type="hidden" value={contact} />
                    <input type="hidden" name="ResponseURL" value={process.env.REACT_APP_PUBLIC_URL + "/payment/payment_response.php"} />
                    <input type="hidden" name="BackendURL" value={process.env.REACT_APP_PUBLIC_URL + "/payment/backend_response.php"}/>  
                </form>
            )}


        </Container>
    );
}

export default Payment;